
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-gym",
      function () {
        return require("private-next-pages/my-gym.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-gym"])
      });
    }
  